import { render } from "./MenuModalMobile.vue?vue&type=template&id=dbc30282&scoped=true"
import script from "./MenuModalMobile.vue?vue&type=script&lang=js"
export * from "./MenuModalMobile.vue?vue&type=script&lang=js"

import "./MenuModalMobile.vue?vue&type=style&index=0&id=dbc30282&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc30282"]])

export default __exports__